import * as Yup from "yup";

export const categoryValidationSchema = Yup.object({
  title: Yup.string()
    .matches(
      /^[A-Za-z\s]+$/,
      "Only letters are allowed"
    )
    .required("Category title is required"),

  slug: Yup.string()
    .matches(
      /^[a-z0-9-]+$/,
      "Slug must contain lowercase letters, numbers and hyphens only"
    )
    .required("Slug is required"),

  description: Yup.string()
    .min(10, "Minimum 10 characters")
    .required("Description is required"),

  isActive: Yup.boolean(),

  image: Yup.mixed().nullable(),
});